import { getDictConfig } from "@/api";
import dayjs from "dayjs";
export default {
  state: {
    config: {
      app_routes: {
        user_agree: "",
        user_agree2: "",
        about:''
      }
    },
    area: "H",
    areaName: "怀化",
    position: {
      lat: "",
      lng: "",
      lastTime: null
    },
    contractNum: {
      effectiveNum: "-",
      lapseNum: "-"
    }
  },
  mutations: {
    SET_AREA(state, area) {
      state.area = area.area;
      state.areaName = area.areaName;
    }
  },
  actions: {
    // async getAppConfig({ state }, code) {
    //   const res = await getDictConfig(code);
    //   var jsonres = JSON.parse(res);
    //   state.config[code] = jsonres;
    //   return jsonres;
    // },
  }
};
